const myView = (state) => (id) =>
  state.myMaker.find((view) => view.view_id === id);
const myList = (state) => state.myList;
const sharedList = (state) => state.sharedList;

const sharedView = (state) => (id) =>
  state.sharedMaker.find((view) => view.view_id === id);

const shareUser = (state) => (viewId) =>
  (state.shareUser.find((users) => users.view_id === viewId) || {}).users;

const userImages = (state) => state.images.USER;

const categoryImages = (state) => (categoryId) =>
  state.images[categoryId] || [];

const imageCategories = (state) => state.categories;

export default {
  shareUser,
  myList,
  myView,
  sharedList,
  sharedView,
  userImages,
  imageCategories,
  categoryImages,
};
